/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * WIE DIE KLAPPZEILE AUSSIEHT (Vorgabe des Betreibers, 17.09.2026:
 * „Dieser Button hat nun zwei Layouts … bitte hier in der Anzeige ein
 * Attribut mit der Auswahl von drei Varianten machen").
 * 
 *   PILLE        — runde Umrandung um die Beschriftung, so breit wie ihr
 *                  Text und mittig; Grund durchsichtig.
 *   BALKEN_FARBE — volle Breite mit einem farbigen Streifen links.
 *                  Die Farbe sagt `klappzeileFarbe`.
 *   BALKEN       — volle Breite, ohne Streifen. Das ist die Form, die es
 *                  vor dem 16.09.2026 allein gab.
 * 
 * Ohne Angabe gilt BALKEN — damit sieht jeder bestehende Baustein aus wie
 * bisher. Der aeltere Schalter `kopfAlsPille` wirkt weiter wie PILLE;
 * geloescht wird er nicht, er steht in bestehenden Daten.
 * @export
 */
export const DatabaseKlappzeile = {
    Pille: 'PILLE',
    BalkenFarbe: 'BALKEN_FARBE',
    Balken: 'BALKEN'
} as const;
export type DatabaseKlappzeile = typeof DatabaseKlappzeile[keyof typeof DatabaseKlappzeile];


export function DatabaseKlappzeileFromJSON(json: any): DatabaseKlappzeile {
    return DatabaseKlappzeileFromJSONTyped(json, false);
}

export function DatabaseKlappzeileFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseKlappzeile {
    return json as DatabaseKlappzeile;
}

export function DatabaseKlappzeileToJSON(value?: DatabaseKlappzeile | null): any {
    return value as any;
}

